import { render, staticRenderFns } from "./DreamsLog.vue?vue&type=template&id=9fcb64a8&scoped=true"
import script from "./DreamsLog.vue?vue&type=script&lang=js"
export * from "./DreamsLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcb64a8",
  null
  
)

export default component.exports